import AddIcon from "@mui/icons-material/Add";
import { Button } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => (
	<CssColumnGrid columns={6}>
		<Button disabled>Default</Button>
		<Button
			design="primary"
			disabled
			startIcon={<AddIcon />}
		>Primary</Button>
		<Button
			design="secondary"
			disabled
			startIcon={<AddIcon />}
		>Secondary</Button>
		<Button
			design="outline"
			disabled
			startIcon={<AddIcon />}
		>Outline</Button>
		<Button
			design="link"
			disabled
			startIcon={<AddIcon />}
		>Link</Button>
		<Button
			design="linkSubtle"
			disabled
			startIcon={<AddIcon />}
		>Link Subtle</Button>
	</CssColumnGrid>
);